import { put, call, takeLatest, delay, select } from "redux-saga/effects";
import { ErrorHandler } from "../../utils/errorHandler";
import * as actions from "./actions";
import {
  getForgotPass,
  getLogin,
  getLogout,
  getRegister,
  getUserDetail,
  get_auth_check,
  get_otp_success,
  get_send_verify_email,
  get_set_new_pass,
  get_set_user_details,
  get_verify_email,
  get_verify_email_code,
} from "./services";
import { getUser } from "../../selectors";
function* __AuthCheck(action) {
  try {
    // const user = yield select(getUser);
    let res = yield get_auth_check();
  } catch (e) {
    yield put(actions.logout());
    action.payload.navigate("/");
  }
}

function* __Logout(action) {
  yield getLogout();
  action.payload.navigate("/");
}
function* __Login(action) {
  try {
    var payload = {
      token: "",
      user: {},
    };
    const res = yield getLogin(action.payload.data);
    if (res) {
      const data = res.data;
      if (data.bearer) {
        get_set_user_details(data);
        payload.user.bearer = data.bearer;
        payload.user.user_id = data.current_user_id;
        yield put(actions.set_state(payload));
        action.payload.success(data);
        yield put(actions.setLoading(false));
      }
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    action.payload.fail(errorMessage);
    yield put(actions.setLoading(false));
    // yield put(actions.login_fail({ error: errorMessage }));
  }
}
function* __REGISTER(action) {
  try {
    var payload = {
      token: "",
      user: {},
    };

    const res = yield getRegister(action.payload);
    if (res.status === 200) {
      const user = yield getUserDetail(res.data.user._id);
      payload.token = res.data.tokens;
      payload.user = user.data.user;
      yield put(
        action.payload.navigate("/check-email", {
          state: { email: action.payload.user.email },
        })
      );
    }
    yield put(actions.login_success(payload));
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

function* __ForgotPass(action) {
  try {
    const res = yield getForgotPass(action.payload);
    if (res.status === 200) {
      const data = res.data;
      if (data.code) {
        action.payload.navigate("/verify-otp", {
          state: { code: data.code, email: action.payload.email },
        });
      }
      yield put(actions.SET_LOADING_FALSE);
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

function* __SENDVERIFYEMAIL(action) {
  try {
    const res = yield get_send_verify_email(action.payload);
    if (res.status === 200) {
      yield put(
        actions.login_success({
          success_msg: "Verification Email Sent Successfully!",
          loading: false,
          error: "",
        })
      );
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

function* __VERIFYEMAIL(action) {
  try {
    yield get_verify_email(action.payload);
    // if (res.status === 200) {
    delay(500);
    yield put(
      actions.login_success({
        success_msg: "Email Verified Successfully!",
        loading: false,
        error: "",
      })
    );

    // }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

function* __VERIFYEMAILCODE(action) {
  try {
    yield get_verify_email_code(action.payload);
    // if (res.status === 200) {
    yield put(
      actions.login_success({
        success_msg: "Account Verified Successfully!",
        loading: false,
        error: "",
      })
    );
    delay(500);
    setTimeout(() => {
      action.payload.navigate("/dashboard");
    }, 2000);
    // }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

function* __OtpSuccess(action) {
  try {
    yield get_otp_success(action.payload);
    // if (res.status === 200) {
    delay(500);
    action.payload.navigate("/set-new-password", {
      state: { code: action.payload.code, email: action.payload.email },
    });
    // }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

function* __SetNewPass(action) {
  try {
    const res = yield get_set_new_pass(action.payload);
    if (res.status === 200) {
      const data = res.data;
      yield put(
        actions.login_success({
          success_msg: data.message,
          loading: false,
          error: "",
        })
      );
      action.payload.navigate("/");
    }
  } catch (e) {
    const errorMessage = yield call(ErrorHandler, e);
    yield put(actions.login_fail({ error: errorMessage }));
  }
}

export function* login() {
  yield takeLatest(actions.LOGIN, __Login);
}

export function* authCheck() {
  yield takeLatest(actions.AUTH_CHECK, __AuthCheck);
}

export function* logout() {
  yield takeLatest(actions.LOGOUT, __Logout);
}

export function* register() {
  yield takeLatest(actions.REGISTER, __REGISTER);
}

export function* forgotPass() {
  yield takeLatest(actions.FORGOT_PASSWORD, __ForgotPass);
}

export function* otp_success() {
  yield takeLatest(actions.OTP_SUCCESS, __OtpSuccess);
}

export function* send_verify_email() {
  yield takeLatest(actions.SEND_VERIFY_EMAIL, __SENDVERIFYEMAIL);
}

export function* verify_email() {
  yield takeLatest(actions.VERIFY_EMAIL, __VERIFYEMAIL);
}

export function* verify_email_code() {
  yield takeLatest(actions.VERIFY_EMAIL_CODE, __VERIFYEMAILCODE);
}

export function* set_new_pass() {
  yield takeLatest(actions.SET_NEW_PASSWORD, __SetNewPass);
}
